<template>
 <v-container fluid fill-height>
        <v-layout v-if="loading" align-center justify-center>
            <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>
        <v-layout v-else>
            <v-flex>
                <v-card>
                    <v-layout pa-2 xs12>
                        <v-flex>
                          <spray-configuration/>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    
</template>

<script>
import sprayConfiguration from '@/components/configuration/SprayConfiguration.vue'

export default {
  data: function() {
        return {
           loading: false
        }
    },
    computed: {

    },
    methods: {

    },
    async created() {
        this.loading = true;
        await this.$store.dispatch("ConfigurationStore/loadSprayConfigurations");
        this.loading = false;
    },
    components: {
        sprayConfiguration: sprayConfiguration
    }
}
</script>

<style>

</style>
